import { Tabs, TabsProps, useMediaQuery } from '@mui/material';
import React from 'react';

/**
 * Standard Tab Bar to be used for logged in and out app states.
 * @param {React.ReactNode} children Child Tabs within Tab Bar.
 * @returns {JSX.Element}
 */
const PrimaryTabs = ({ children, ...props }: TabsProps & { children: React.ReactNode }) => {
  const medium_viewport: boolean = useMediaQuery('(min-width:900px)');

  return (
    <Tabs
      {...props}
      slotProps={{
        indicator: { style: { display: 'none' } },
        list: {
          style: {
            gap: medium_viewport ? 'min(20px, 3%)' : 10,
            alignItems: 'center'
          }
        }
      }}
      orientation={medium_viewport ? 'horizontal' : 'vertical'}
    >
      {children}
    </Tabs>
  );
};

export default PrimaryTabs;
